export default "__VITE_ASSET__3A4LnZQm__"